import { combineReducers } from 'redux';

import user from './user';
import boat from './boat';

export default combineReducers({
  user,
  boat
});



// WEBPACK FOOTER //
// ./src/app/store/reducers/root.js